import styles from './SignIn.module.css';
import React, { Component } from 'react';

import { LanguageContext } from '../../i18n/LanguageContext';
import { getLang } from '../../i18n/i18n';

export class SignIn extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        if (!localStorage.getItem('lang')) {
            localStorage.setItem('lang', 'es');
        }

        const selectedLanguage = localStorage.getItem('lang');
        const lang = getLang(selectedLanguage);
        console.log(`Sign In`, this.context);

        this.state = {
            email: '',
            password: '',
            lang: lang,
            selectedLanguage: selectedLanguage
        }

        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onLanguageChange = this.onLanguageChange.bind(this);
    }

    handleChangeEmail(event) {
        this.setState({ email: event.target.value });
    }

    handleChangePassword(event) {
        this.setState({ password: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.authenticate(this.state.email, this.state.password);
    }

    onLanguageChange(e) {
        const selectedLanguage = e.target.value;
        localStorage.setItem('lang', selectedLanguage);

        const lang = getLang(selectedLanguage);
        this.setState({ lang: lang, selectedLanguage: selectedLanguage });
    }

    render() {
        let errorComponent;
        if (!!this.props.errorMessage) {
            errorComponent = <div className={styles['error-message']}>{this.props.errorMessage}</div>
        }

        const spanishIcon = '🇵🇦';
        const englishIcon = '🇺🇸';

        const spanishText = localStorage.getItem('lang') === 'es' ? 'Español' : 'Spanish';
        const englishText = localStorage.getItem('lang') === 'es' ? 'Inglés' : 'English';

        return (
            <LanguageContext.Provider value={this.state.lang}>
                <div className={`container-fluid ${styles['sign-in-container']}`}>
                    <div className="row">
                        <div className="col-md-4 offset-md-4">
                            <div className={styles['account-wall']}>
                                <img className={styles['profile-img']} style={{ width: 191 }} src="/img/cpl_logo.png" alt="" />
                                <form className={styles['form-signin']} onSubmit={this.handleSubmit}>
                                    <div className={styles['lang-container']}>
                                        <select
                                            value={this.state.selectedLanguage}
                                            onChange={this.onLanguageChange}>
                                            <option value='es'>{spanishIcon} {spanishText}</option>
                                            <option value="en">{englishIcon} {englishText}</option>
                                        </select>
                                    </div>
                                    <input type="text" className="form-control" placeholder={this.state.lang['EMAIL']} value={this.state.email} onChange={this.handleChangeEmail} autoFocus />
                                    <input type="password" className="form-control" placeholder={this.state.lang['PASSWORD']} value={this.state.password} onChange={this.handleChangePassword} />
                                    
                                        <button className="btn btn-lg btn-primary btn-block" type="submit">{this.state.lang['SIGN_IN']}</button>
                                    
                                </form>
                            </div>
                            {errorComponent}
                        </div>
                    </div>
                </div>
            </LanguageContext.Provider>
        );
    }
}